import * as _viewerApi2 from "@shapediver/viewer.api.general";
var _viewerApi = _viewerApi2;
try {
  if ("default" in _viewerApi2) _viewerApi = _viewerApi2.default;
} catch (e) {}
import * as _viewerShared2 from "@shapediver/viewer.shared.types";
var _viewerShared = _viewerShared2;
try {
  if ("default" in _viewerShared2) _viewerShared = _viewerShared2.default;
} catch (e) {}
import * as _viewerShared4 from "@shapediver/viewer.shared.math";
var _viewerShared3 = _viewerShared4;
try {
  if ("default" in _viewerShared4) _viewerShared3 = _viewerShared4.default;
} catch (e) {}
import _main from "./main";
import * as _viewerShared6 from "@shapediver/viewer.shared.services";
var _viewerShared5 = _viewerShared6;
try {
  if ("default" in _viewerShared6) _viewerShared5 = _viewerShared6.default;
} catch (e) {}
import * as _viewerDataEngine2 from "@shapediver/viewer.data-engine.shared-types";
var _viewerDataEngine = _viewerDataEngine2;
try {
  if ("default" in _viewerDataEngine2) _viewerDataEngine = _viewerDataEngine2.default;
} catch (e) {}
import * as _viewerSessionEngine2 from "@shapediver/viewer.session-engine.session-engine";
var _viewerSessionEngine = _viewerSessionEngine2;
try {
  if ("default" in _viewerSessionEngine2) _viewerSessionEngine = _viewerSessionEngine2.default;
} catch (e) {}
import * as _viewerShared8 from "@shapediver/viewer.shared.node-tree";
var _viewerShared7 = _viewerShared8;
try {
  if ("default" in _viewerShared8) _viewerShared7 = _viewerShared8.default;
} catch (e) {}
import _OutputApiData from "./implementation/data/OutputApiData";
import _SessionApiData from "./implementation/data/SessionApiData";
import * as _sdk2 from "@shapediver/sdk.geometry-api-sdk-v2";
var _sdk = _sdk2;
try {
  if ("default" in _sdk2) _sdk = _sdk2.default;
} catch (e) {}
var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MaterialStandardData = exports.ShapeDiverResponseModelComputationStatus = exports.Sphere = exports.Box = exports.EVENTTYPE_TASK = exports.EVENTTYPE_DRAWING_TOOLS = exports.EVENTTYPE_GUMBALL = exports.EVENTTYPE_INTERACTION = exports.EVENTTYPE_VIEWPORT = exports.EVENTTYPE_SESSION = exports.EVENTTYPE_SCENE = exports.EVENTTYPE_RENDERING = exports.EVENTTYPE_PARAMETER = exports.EVENTTYPE_OUTPUT = exports.EVENTTYPE_CAMERA = exports.EVENTTYPE = exports.TASK_TYPE = exports.SESSION_SETTINGS_MODE = exports.SDTF_TYPEHINT = exports.TEXTURE_FILTERING = exports.TEXTURE_WRAPPING = exports.MATERIAL_TYPE = exports.MATERIAL_SHADING = exports.MATERIAL_ALPHA = exports.MATERIAL_SIDE = exports.PRIMITIVE_MODE = exports.LOGGING_LEVEL = exports.TAG3D_JUSTIFICATION = exports.PARAMETER_VISUALIZATION = exports.EXPORT_TYPE = exports.PARAMETER_TYPE = exports.TreeNode = exports.Tree = exports.version = exports.generalOptions = exports.sceneTree = exports.removeListener = exports.addListener = exports.sessions = exports.createSession = exports.OutputApiData = exports.SessionApiData = exports.validateGumballParameterSettings = exports.IGumballParameterJsonSchema = exports.isInteractionGumballParameterSettings = exports.validateSelectionParameterSettings = exports.ISelectionParameterJsonSchema = exports.isInteractionSelectionParameterSettings = exports.validateInteractionParameterSettings = exports.IInteractionParameterJsonSchema = void 0;
exports.isViewerSettingsError = exports.isViewerWebGLError = exports.isViewerEnvironmentMapError = exports.isViewerDataProcessingError = exports.isViewerUnknownError = exports.isViewerError = exports.ShapeDiverGeometryBackendResponseErrorType = exports.ShapeDiverGeometryBackendResponseError = exports.ShapeDiverGeometryBackendRequestError = exports.ShapeDiverGeometryBackendError = exports.ShapeDiverViewerDrawingToolsError = exports.ShapeDiverViewerInteractionError = exports.ShapeDiverViewerValidationError = exports.ShapeDiverViewerCameraError = exports.ShapeDiverViewerLightError = exports.ShapeDiverViewerArError = exports.ShapeDiverViewerUnknownError = exports.ShapeDiverViewerViewportError = exports.ShapeDiverViewerSessionError = exports.ShapeDiverViewerSettingsError = exports.ShapeDiverViewerWebGLError = exports.ShapeDiverViewerEnvironmentMapError = exports.ShapeDiverViewerDataProcessingError = exports.ShapeDiverViewerError = exports.ShapeDiverViewerErrorType = exports.SessionOutputData = exports.SessionData = exports.SdtfPrimitiveTypeGuard = exports.SDTFItemData = exports.SDTFAttributeData = exports.SDTFAttributesData = exports.SDTFOverviewData = exports.CustomData = exports.HTMLElementAnchorData = exports.HTMLElementAnchorImageData = exports.HTMLElementAnchorTextData = exports.HTMLElementAnchorCustomData = exports.MaterialVariantsData = exports.PrimitiveData = exports.AttributeData = exports.GeometryData = exports.AnimationData = exports.MapData = exports.MaterialBasicLineData = exports.MaterialMultiPointData = exports.MaterialPointData = exports.MaterialGemData = exports.MaterialSpecularGlossinessData = exports.MaterialShadowData = exports.MaterialUnlitData = void 0;
exports.isViewerGeometryBackendResponseError = exports.isViewerGeometryBackendRequestError = exports.isViewerGeometryBackendGenericError = exports.isViewerGeometryBackendError = exports.isViewerDrawingToolsError = exports.isViewerInteractionError = exports.isViewerValidationError = exports.isARError = exports.isViewerCameraError = exports.isViewerLightError = exports.isViewerViewportError = exports.isViewerSessionError = void 0;
const viewer_api_general_1 = _viewerApi;
Object.defineProperty(exports, "addListener", {
  enumerable: true,
  get: function () {
    return viewer_api_general_1.addListener;
  }
});
Object.defineProperty(exports, "generalOptions", {
  enumerable: true,
  get: function () {
    return viewer_api_general_1.generalOptions;
  }
});
Object.defineProperty(exports, "removeListener", {
  enumerable: true,
  get: function () {
    return viewer_api_general_1.removeListener;
  }
});
Object.defineProperty(exports, "sceneTree", {
  enumerable: true,
  get: function () {
    return viewer_api_general_1.sceneTree;
  }
});
Object.defineProperty(exports, "version", {
  enumerable: true,
  get: function () {
    return viewer_api_general_1.version;
  }
});
const viewer_shared_types_1 = _viewerShared;
Object.defineProperty(exports, "AnimationData", {
  enumerable: true,
  get: function () {
    return viewer_shared_types_1.AnimationData;
  }
});
Object.defineProperty(exports, "AttributeData", {
  enumerable: true,
  get: function () {
    return viewer_shared_types_1.AttributeData;
  }
});
Object.defineProperty(exports, "CustomData", {
  enumerable: true,
  get: function () {
    return viewer_shared_types_1.CustomData;
  }
});
Object.defineProperty(exports, "GeometryData", {
  enumerable: true,
  get: function () {
    return viewer_shared_types_1.GeometryData;
  }
});
Object.defineProperty(exports, "HTMLElementAnchorCustomData", {
  enumerable: true,
  get: function () {
    return viewer_shared_types_1.HTMLElementAnchorCustomData;
  }
});
Object.defineProperty(exports, "HTMLElementAnchorData", {
  enumerable: true,
  get: function () {
    return viewer_shared_types_1.HTMLElementAnchorData;
  }
});
Object.defineProperty(exports, "HTMLElementAnchorImageData", {
  enumerable: true,
  get: function () {
    return viewer_shared_types_1.HTMLElementAnchorImageData;
  }
});
Object.defineProperty(exports, "HTMLElementAnchorTextData", {
  enumerable: true,
  get: function () {
    return viewer_shared_types_1.HTMLElementAnchorTextData;
  }
});
Object.defineProperty(exports, "IGumballParameterJsonSchema", {
  enumerable: true,
  get: function () {
    return viewer_shared_types_1.IGumballParameterJsonSchema;
  }
});
Object.defineProperty(exports, "IInteractionParameterJsonSchema", {
  enumerable: true,
  get: function () {
    return viewer_shared_types_1.IInteractionParameterJsonSchema;
  }
});
Object.defineProperty(exports, "ISelectionParameterJsonSchema", {
  enumerable: true,
  get: function () {
    return viewer_shared_types_1.ISelectionParameterJsonSchema;
  }
});
Object.defineProperty(exports, "isInteractionGumballParameterSettings", {
  enumerable: true,
  get: function () {
    return viewer_shared_types_1.isInteractionGumballParameterSettings;
  }
});
Object.defineProperty(exports, "isInteractionSelectionParameterSettings", {
  enumerable: true,
  get: function () {
    return viewer_shared_types_1.isInteractionSelectionParameterSettings;
  }
});
Object.defineProperty(exports, "MapData", {
  enumerable: true,
  get: function () {
    return viewer_shared_types_1.MapData;
  }
});
Object.defineProperty(exports, "MATERIAL_ALPHA", {
  enumerable: true,
  get: function () {
    return viewer_shared_types_1.MATERIAL_ALPHA;
  }
});
Object.defineProperty(exports, "MATERIAL_SHADING", {
  enumerable: true,
  get: function () {
    return viewer_shared_types_1.MATERIAL_SHADING;
  }
});
Object.defineProperty(exports, "MATERIAL_SIDE", {
  enumerable: true,
  get: function () {
    return viewer_shared_types_1.MATERIAL_SIDE;
  }
});
Object.defineProperty(exports, "MATERIAL_TYPE", {
  enumerable: true,
  get: function () {
    return viewer_shared_types_1.MATERIAL_TYPE;
  }
});
Object.defineProperty(exports, "MaterialBasicLineData", {
  enumerable: true,
  get: function () {
    return viewer_shared_types_1.MaterialBasicLineData;
  }
});
Object.defineProperty(exports, "MaterialGemData", {
  enumerable: true,
  get: function () {
    return viewer_shared_types_1.MaterialGemData;
  }
});
Object.defineProperty(exports, "MaterialMultiPointData", {
  enumerable: true,
  get: function () {
    return viewer_shared_types_1.MaterialMultiPointData;
  }
});
Object.defineProperty(exports, "MaterialPointData", {
  enumerable: true,
  get: function () {
    return viewer_shared_types_1.MaterialPointData;
  }
});
Object.defineProperty(exports, "MaterialShadowData", {
  enumerable: true,
  get: function () {
    return viewer_shared_types_1.MaterialShadowData;
  }
});
Object.defineProperty(exports, "MaterialSpecularGlossinessData", {
  enumerable: true,
  get: function () {
    return viewer_shared_types_1.MaterialSpecularGlossinessData;
  }
});
Object.defineProperty(exports, "MaterialStandardData", {
  enumerable: true,
  get: function () {
    return viewer_shared_types_1.MaterialStandardData;
  }
});
Object.defineProperty(exports, "MaterialUnlitData", {
  enumerable: true,
  get: function () {
    return viewer_shared_types_1.MaterialUnlitData;
  }
});
Object.defineProperty(exports, "MaterialVariantsData", {
  enumerable: true,
  get: function () {
    return viewer_shared_types_1.MaterialVariantsData;
  }
});
Object.defineProperty(exports, "PARAMETER_TYPE", {
  enumerable: true,
  get: function () {
    return viewer_shared_types_1.PARAMETER_TYPE;
  }
});
Object.defineProperty(exports, "PARAMETER_VISUALIZATION", {
  enumerable: true,
  get: function () {
    return viewer_shared_types_1.PARAMETER_VISUALIZATION;
  }
});
Object.defineProperty(exports, "PRIMITIVE_MODE", {
  enumerable: true,
  get: function () {
    return viewer_shared_types_1.PRIMITIVE_MODE;
  }
});
Object.defineProperty(exports, "PrimitiveData", {
  enumerable: true,
  get: function () {
    return viewer_shared_types_1.PrimitiveData;
  }
});
Object.defineProperty(exports, "SDTF_TYPEHINT", {
  enumerable: true,
  get: function () {
    return viewer_shared_types_1.SDTF_TYPEHINT;
  }
});
Object.defineProperty(exports, "SDTFAttributeData", {
  enumerable: true,
  get: function () {
    return viewer_shared_types_1.SDTFAttributeData;
  }
});
Object.defineProperty(exports, "SDTFAttributesData", {
  enumerable: true,
  get: function () {
    return viewer_shared_types_1.SDTFAttributesData;
  }
});
Object.defineProperty(exports, "SDTFItemData", {
  enumerable: true,
  get: function () {
    return viewer_shared_types_1.SDTFItemData;
  }
});
Object.defineProperty(exports, "SDTFOverviewData", {
  enumerable: true,
  get: function () {
    return viewer_shared_types_1.SDTFOverviewData;
  }
});
Object.defineProperty(exports, "SdtfPrimitiveTypeGuard", {
  enumerable: true,
  get: function () {
    return viewer_shared_types_1.SdtfPrimitiveTypeGuard;
  }
});
Object.defineProperty(exports, "TASK_TYPE", {
  enumerable: true,
  get: function () {
    return viewer_shared_types_1.TASK_TYPE;
  }
});
Object.defineProperty(exports, "TEXTURE_FILTERING", {
  enumerable: true,
  get: function () {
    return viewer_shared_types_1.TEXTURE_FILTERING;
  }
});
Object.defineProperty(exports, "TEXTURE_WRAPPING", {
  enumerable: true,
  get: function () {
    return viewer_shared_types_1.TEXTURE_WRAPPING;
  }
});
Object.defineProperty(exports, "validateGumballParameterSettings", {
  enumerable: true,
  get: function () {
    return viewer_shared_types_1.validateGumballParameterSettings;
  }
});
Object.defineProperty(exports, "validateInteractionParameterSettings", {
  enumerable: true,
  get: function () {
    return viewer_shared_types_1.validateInteractionParameterSettings;
  }
});
Object.defineProperty(exports, "validateSelectionParameterSettings", {
  enumerable: true,
  get: function () {
    return viewer_shared_types_1.validateSelectionParameterSettings;
  }
});
const viewer_shared_math_1 = _viewerShared3;
Object.defineProperty(exports, "Box", {
  enumerable: true,
  get: function () {
    return viewer_shared_math_1.Box;
  }
});
Object.defineProperty(exports, "Sphere", {
  enumerable: true,
  get: function () {
    return viewer_shared_math_1.Sphere;
  }
});
const main_1 = _main;
Object.defineProperty(exports, "createSession", {
  enumerable: true,
  get: function () {
    return main_1.createSession;
  }
});
Object.defineProperty(exports, "sessions", {
  enumerable: true,
  get: function () {
    return main_1.sessions;
  }
});
const viewer_shared_services_1 = _viewerShared5;
Object.defineProperty(exports, "EVENTTYPE", {
  enumerable: true,
  get: function () {
    return viewer_shared_services_1.EVENTTYPE;
  }
});
Object.defineProperty(exports, "EVENTTYPE_CAMERA", {
  enumerable: true,
  get: function () {
    return viewer_shared_services_1.EVENTTYPE_CAMERA;
  }
});
Object.defineProperty(exports, "EVENTTYPE_DRAWING_TOOLS", {
  enumerable: true,
  get: function () {
    return viewer_shared_services_1.EVENTTYPE_DRAWING_TOOLS;
  }
});
Object.defineProperty(exports, "EVENTTYPE_GUMBALL", {
  enumerable: true,
  get: function () {
    return viewer_shared_services_1.EVENTTYPE_GUMBALL;
  }
});
Object.defineProperty(exports, "EVENTTYPE_INTERACTION", {
  enumerable: true,
  get: function () {
    return viewer_shared_services_1.EVENTTYPE_INTERACTION;
  }
});
Object.defineProperty(exports, "EVENTTYPE_OUTPUT", {
  enumerable: true,
  get: function () {
    return viewer_shared_services_1.EVENTTYPE_OUTPUT;
  }
});
Object.defineProperty(exports, "EVENTTYPE_PARAMETER", {
  enumerable: true,
  get: function () {
    return viewer_shared_services_1.EVENTTYPE_PARAMETER;
  }
});
Object.defineProperty(exports, "EVENTTYPE_RENDERING", {
  enumerable: true,
  get: function () {
    return viewer_shared_services_1.EVENTTYPE_RENDERING;
  }
});
Object.defineProperty(exports, "EVENTTYPE_SCENE", {
  enumerable: true,
  get: function () {
    return viewer_shared_services_1.EVENTTYPE_SCENE;
  }
});
Object.defineProperty(exports, "EVENTTYPE_SESSION", {
  enumerable: true,
  get: function () {
    return viewer_shared_services_1.EVENTTYPE_SESSION;
  }
});
Object.defineProperty(exports, "EVENTTYPE_TASK", {
  enumerable: true,
  get: function () {
    return viewer_shared_services_1.EVENTTYPE_TASK;
  }
});
Object.defineProperty(exports, "EVENTTYPE_VIEWPORT", {
  enumerable: true,
  get: function () {
    return viewer_shared_services_1.EVENTTYPE_VIEWPORT;
  }
});
Object.defineProperty(exports, "isARError", {
  enumerable: true,
  get: function () {
    return viewer_shared_services_1.isARError;
  }
});
Object.defineProperty(exports, "isViewerCameraError", {
  enumerable: true,
  get: function () {
    return viewer_shared_services_1.isViewerCameraError;
  }
});
Object.defineProperty(exports, "isViewerDataProcessingError", {
  enumerable: true,
  get: function () {
    return viewer_shared_services_1.isViewerDataProcessingError;
  }
});
Object.defineProperty(exports, "isViewerDrawingToolsError", {
  enumerable: true,
  get: function () {
    return viewer_shared_services_1.isViewerDrawingToolsError;
  }
});
Object.defineProperty(exports, "isViewerEnvironmentMapError", {
  enumerable: true,
  get: function () {
    return viewer_shared_services_1.isViewerEnvironmentMapError;
  }
});
Object.defineProperty(exports, "isViewerError", {
  enumerable: true,
  get: function () {
    return viewer_shared_services_1.isViewerError;
  }
});
Object.defineProperty(exports, "isViewerGeometryBackendError", {
  enumerable: true,
  get: function () {
    return viewer_shared_services_1.isViewerGeometryBackendError;
  }
});
Object.defineProperty(exports, "isViewerGeometryBackendGenericError", {
  enumerable: true,
  get: function () {
    return viewer_shared_services_1.isViewerGeometryBackendGenericError;
  }
});
Object.defineProperty(exports, "isViewerGeometryBackendRequestError", {
  enumerable: true,
  get: function () {
    return viewer_shared_services_1.isViewerGeometryBackendRequestError;
  }
});
Object.defineProperty(exports, "isViewerGeometryBackendResponseError", {
  enumerable: true,
  get: function () {
    return viewer_shared_services_1.isViewerGeometryBackendResponseError;
  }
});
Object.defineProperty(exports, "isViewerInteractionError", {
  enumerable: true,
  get: function () {
    return viewer_shared_services_1.isViewerInteractionError;
  }
});
Object.defineProperty(exports, "isViewerLightError", {
  enumerable: true,
  get: function () {
    return viewer_shared_services_1.isViewerLightError;
  }
});
Object.defineProperty(exports, "isViewerSessionError", {
  enumerable: true,
  get: function () {
    return viewer_shared_services_1.isViewerSessionError;
  }
});
Object.defineProperty(exports, "isViewerSettingsError", {
  enumerable: true,
  get: function () {
    return viewer_shared_services_1.isViewerSettingsError;
  }
});
Object.defineProperty(exports, "isViewerUnknownError", {
  enumerable: true,
  get: function () {
    return viewer_shared_services_1.isViewerUnknownError;
  }
});
Object.defineProperty(exports, "isViewerValidationError", {
  enumerable: true,
  get: function () {
    return viewer_shared_services_1.isViewerValidationError;
  }
});
Object.defineProperty(exports, "isViewerViewportError", {
  enumerable: true,
  get: function () {
    return viewer_shared_services_1.isViewerViewportError;
  }
});
Object.defineProperty(exports, "isViewerWebGLError", {
  enumerable: true,
  get: function () {
    return viewer_shared_services_1.isViewerWebGLError;
  }
});
Object.defineProperty(exports, "LOGGING_LEVEL", {
  enumerable: true,
  get: function () {
    return viewer_shared_services_1.LOGGING_LEVEL;
  }
});
Object.defineProperty(exports, "SESSION_SETTINGS_MODE", {
  enumerable: true,
  get: function () {
    return viewer_shared_services_1.SESSION_SETTINGS_MODE;
  }
});
Object.defineProperty(exports, "ShapeDiverGeometryBackendError", {
  enumerable: true,
  get: function () {
    return viewer_shared_services_1.ShapeDiverGeometryBackendError;
  }
});
Object.defineProperty(exports, "ShapeDiverGeometryBackendRequestError", {
  enumerable: true,
  get: function () {
    return viewer_shared_services_1.ShapeDiverGeometryBackendRequestError;
  }
});
Object.defineProperty(exports, "ShapeDiverGeometryBackendResponseError", {
  enumerable: true,
  get: function () {
    return viewer_shared_services_1.ShapeDiverGeometryBackendResponseError;
  }
});
Object.defineProperty(exports, "ShapeDiverGeometryBackendResponseErrorType", {
  enumerable: true,
  get: function () {
    return viewer_shared_services_1.ShapeDiverGeometryBackendResponseErrorType;
  }
});
Object.defineProperty(exports, "ShapeDiverViewerArError", {
  enumerable: true,
  get: function () {
    return viewer_shared_services_1.ShapeDiverViewerArError;
  }
});
Object.defineProperty(exports, "ShapeDiverViewerCameraError", {
  enumerable: true,
  get: function () {
    return viewer_shared_services_1.ShapeDiverViewerCameraError;
  }
});
Object.defineProperty(exports, "ShapeDiverViewerDataProcessingError", {
  enumerable: true,
  get: function () {
    return viewer_shared_services_1.ShapeDiverViewerDataProcessingError;
  }
});
Object.defineProperty(exports, "ShapeDiverViewerDrawingToolsError", {
  enumerable: true,
  get: function () {
    return viewer_shared_services_1.ShapeDiverViewerDrawingToolsError;
  }
});
Object.defineProperty(exports, "ShapeDiverViewerEnvironmentMapError", {
  enumerable: true,
  get: function () {
    return viewer_shared_services_1.ShapeDiverViewerEnvironmentMapError;
  }
});
Object.defineProperty(exports, "ShapeDiverViewerError", {
  enumerable: true,
  get: function () {
    return viewer_shared_services_1.ShapeDiverViewerError;
  }
});
Object.defineProperty(exports, "ShapeDiverViewerErrorType", {
  enumerable: true,
  get: function () {
    return viewer_shared_services_1.ShapeDiverViewerErrorType;
  }
});
Object.defineProperty(exports, "ShapeDiverViewerInteractionError", {
  enumerable: true,
  get: function () {
    return viewer_shared_services_1.ShapeDiverViewerInteractionError;
  }
});
Object.defineProperty(exports, "ShapeDiverViewerLightError", {
  enumerable: true,
  get: function () {
    return viewer_shared_services_1.ShapeDiverViewerLightError;
  }
});
Object.defineProperty(exports, "ShapeDiverViewerSessionError", {
  enumerable: true,
  get: function () {
    return viewer_shared_services_1.ShapeDiverViewerSessionError;
  }
});
Object.defineProperty(exports, "ShapeDiverViewerSettingsError", {
  enumerable: true,
  get: function () {
    return viewer_shared_services_1.ShapeDiverViewerSettingsError;
  }
});
Object.defineProperty(exports, "ShapeDiverViewerUnknownError", {
  enumerable: true,
  get: function () {
    return viewer_shared_services_1.ShapeDiverViewerUnknownError;
  }
});
Object.defineProperty(exports, "ShapeDiverViewerValidationError", {
  enumerable: true,
  get: function () {
    return viewer_shared_services_1.ShapeDiverViewerValidationError;
  }
});
Object.defineProperty(exports, "ShapeDiverViewerViewportError", {
  enumerable: true,
  get: function () {
    return viewer_shared_services_1.ShapeDiverViewerViewportError;
  }
});
Object.defineProperty(exports, "ShapeDiverViewerWebGLError", {
  enumerable: true,
  get: function () {
    return viewer_shared_services_1.ShapeDiverViewerWebGLError;
  }
});
const viewer_data_engine_shared_types_1 = _viewerDataEngine;
Object.defineProperty(exports, "TAG3D_JUSTIFICATION", {
  enumerable: true,
  get: function () {
    return viewer_data_engine_shared_types_1.TAG3D_JUSTIFICATION;
  }
});
const viewer_session_engine_session_engine_1 = _viewerSessionEngine;
Object.defineProperty(exports, "SessionData", {
  enumerable: true,
  get: function () {
    return viewer_session_engine_session_engine_1.SessionData;
  }
});
Object.defineProperty(exports, "SessionOutputData", {
  enumerable: true,
  get: function () {
    return viewer_session_engine_session_engine_1.SessionOutputData;
  }
});
const viewer_shared_node_tree_1 = _viewerShared7;
Object.defineProperty(exports, "Tree", {
  enumerable: true,
  get: function () {
    return viewer_shared_node_tree_1.Tree;
  }
});
Object.defineProperty(exports, "TreeNode", {
  enumerable: true,
  get: function () {
    return viewer_shared_node_tree_1.TreeNode;
  }
});
const OutputApiData_1 = _OutputApiData;
Object.defineProperty(exports, "OutputApiData", {
  enumerable: true,
  get: function () {
    return OutputApiData_1.OutputApiData;
  }
});
const SessionApiData_1 = _SessionApiData;
Object.defineProperty(exports, "SessionApiData", {
  enumerable: true,
  get: function () {
    return SessionApiData_1.SessionApiData;
  }
});
const sdk_geometry_api_sdk_v2_1 = _sdk;
Object.defineProperty(exports, "ShapeDiverResponseModelComputationStatus", {
  enumerable: true,
  get: function () {
    return sdk_geometry_api_sdk_v2_1.ShapeDiverResponseModelComputationStatus;
  }
});
const sdk_geometry_api_sdk_v2_2 = _sdk;
Object.defineProperty(exports, "EXPORT_TYPE", {
  enumerable: true,
  get: function () {
    return sdk_geometry_api_sdk_v2_2.ShapeDiverResponseExportDefinitionType;
  }
});
//# sourceMappingURL=index.js.map
export default exports;
export const __esModule = exports.__esModule,
  MaterialStandardData = exports.MaterialStandardData,
  ShapeDiverResponseModelComputationStatus = exports.ShapeDiverResponseModelComputationStatus,
  Sphere = exports.Sphere,
  Box = exports.Box,
  EVENTTYPE_TASK = exports.EVENTTYPE_TASK,
  EVENTTYPE_DRAWING_TOOLS = exports.EVENTTYPE_DRAWING_TOOLS,
  EVENTTYPE_GUMBALL = exports.EVENTTYPE_GUMBALL,
  EVENTTYPE_INTERACTION = exports.EVENTTYPE_INTERACTION,
  EVENTTYPE_VIEWPORT = exports.EVENTTYPE_VIEWPORT,
  EVENTTYPE_SESSION = exports.EVENTTYPE_SESSION,
  EVENTTYPE_SCENE = exports.EVENTTYPE_SCENE,
  EVENTTYPE_RENDERING = exports.EVENTTYPE_RENDERING,
  EVENTTYPE_PARAMETER = exports.EVENTTYPE_PARAMETER,
  EVENTTYPE_OUTPUT = exports.EVENTTYPE_OUTPUT,
  EVENTTYPE_CAMERA = exports.EVENTTYPE_CAMERA,
  EVENTTYPE = exports.EVENTTYPE,
  TASK_TYPE = exports.TASK_TYPE,
  SESSION_SETTINGS_MODE = exports.SESSION_SETTINGS_MODE,
  SDTF_TYPEHINT = exports.SDTF_TYPEHINT,
  TEXTURE_FILTERING = exports.TEXTURE_FILTERING,
  TEXTURE_WRAPPING = exports.TEXTURE_WRAPPING,
  MATERIAL_TYPE = exports.MATERIAL_TYPE,
  MATERIAL_SHADING = exports.MATERIAL_SHADING,
  MATERIAL_ALPHA = exports.MATERIAL_ALPHA,
  MATERIAL_SIDE = exports.MATERIAL_SIDE,
  PRIMITIVE_MODE = exports.PRIMITIVE_MODE,
  LOGGING_LEVEL = exports.LOGGING_LEVEL,
  TAG3D_JUSTIFICATION = exports.TAG3D_JUSTIFICATION,
  PARAMETER_VISUALIZATION = exports.PARAMETER_VISUALIZATION,
  EXPORT_TYPE = exports.EXPORT_TYPE,
  PARAMETER_TYPE = exports.PARAMETER_TYPE,
  TreeNode = exports.TreeNode,
  Tree = exports.Tree,
  version = exports.version,
  generalOptions = exports.generalOptions,
  sceneTree = exports.sceneTree,
  removeListener = exports.removeListener,
  addListener = exports.addListener,
  sessions = exports.sessions,
  createSession = exports.createSession,
  OutputApiData = exports.OutputApiData,
  SessionApiData = exports.SessionApiData,
  validateGumballParameterSettings = exports.validateGumballParameterSettings,
  IGumballParameterJsonSchema = exports.IGumballParameterJsonSchema,
  isInteractionGumballParameterSettings = exports.isInteractionGumballParameterSettings,
  validateSelectionParameterSettings = exports.validateSelectionParameterSettings,
  ISelectionParameterJsonSchema = exports.ISelectionParameterJsonSchema,
  isInteractionSelectionParameterSettings = exports.isInteractionSelectionParameterSettings,
  validateInteractionParameterSettings = exports.validateInteractionParameterSettings,
  IInteractionParameterJsonSchema = exports.IInteractionParameterJsonSchema,
  isViewerSettingsError = exports.isViewerSettingsError,
  isViewerWebGLError = exports.isViewerWebGLError,
  isViewerEnvironmentMapError = exports.isViewerEnvironmentMapError,
  isViewerDataProcessingError = exports.isViewerDataProcessingError,
  isViewerUnknownError = exports.isViewerUnknownError,
  isViewerError = exports.isViewerError,
  ShapeDiverGeometryBackendResponseErrorType = exports.ShapeDiverGeometryBackendResponseErrorType,
  ShapeDiverGeometryBackendResponseError = exports.ShapeDiverGeometryBackendResponseError,
  ShapeDiverGeometryBackendRequestError = exports.ShapeDiverGeometryBackendRequestError,
  ShapeDiverGeometryBackendError = exports.ShapeDiverGeometryBackendError,
  ShapeDiverViewerDrawingToolsError = exports.ShapeDiverViewerDrawingToolsError,
  ShapeDiverViewerInteractionError = exports.ShapeDiverViewerInteractionError,
  ShapeDiverViewerValidationError = exports.ShapeDiverViewerValidationError,
  ShapeDiverViewerCameraError = exports.ShapeDiverViewerCameraError,
  ShapeDiverViewerLightError = exports.ShapeDiverViewerLightError,
  ShapeDiverViewerArError = exports.ShapeDiverViewerArError,
  ShapeDiverViewerUnknownError = exports.ShapeDiverViewerUnknownError,
  ShapeDiverViewerViewportError = exports.ShapeDiverViewerViewportError,
  ShapeDiverViewerSessionError = exports.ShapeDiverViewerSessionError,
  ShapeDiverViewerSettingsError = exports.ShapeDiverViewerSettingsError,
  ShapeDiverViewerWebGLError = exports.ShapeDiverViewerWebGLError,
  ShapeDiverViewerEnvironmentMapError = exports.ShapeDiverViewerEnvironmentMapError,
  ShapeDiverViewerDataProcessingError = exports.ShapeDiverViewerDataProcessingError,
  ShapeDiverViewerError = exports.ShapeDiverViewerError,
  ShapeDiverViewerErrorType = exports.ShapeDiverViewerErrorType,
  SessionOutputData = exports.SessionOutputData,
  SessionData = exports.SessionData,
  SdtfPrimitiveTypeGuard = exports.SdtfPrimitiveTypeGuard,
  SDTFItemData = exports.SDTFItemData,
  SDTFAttributeData = exports.SDTFAttributeData,
  SDTFAttributesData = exports.SDTFAttributesData,
  SDTFOverviewData = exports.SDTFOverviewData,
  CustomData = exports.CustomData,
  HTMLElementAnchorData = exports.HTMLElementAnchorData,
  HTMLElementAnchorImageData = exports.HTMLElementAnchorImageData,
  HTMLElementAnchorTextData = exports.HTMLElementAnchorTextData,
  HTMLElementAnchorCustomData = exports.HTMLElementAnchorCustomData,
  MaterialVariantsData = exports.MaterialVariantsData,
  PrimitiveData = exports.PrimitiveData,
  AttributeData = exports.AttributeData,
  GeometryData = exports.GeometryData,
  AnimationData = exports.AnimationData,
  MapData = exports.MapData,
  MaterialBasicLineData = exports.MaterialBasicLineData,
  MaterialMultiPointData = exports.MaterialMultiPointData,
  MaterialPointData = exports.MaterialPointData,
  MaterialGemData = exports.MaterialGemData,
  MaterialSpecularGlossinessData = exports.MaterialSpecularGlossinessData,
  MaterialShadowData = exports.MaterialShadowData,
  MaterialUnlitData = exports.MaterialUnlitData,
  isViewerGeometryBackendResponseError = exports.isViewerGeometryBackendResponseError,
  isViewerGeometryBackendRequestError = exports.isViewerGeometryBackendRequestError,
  isViewerGeometryBackendGenericError = exports.isViewerGeometryBackendGenericError,
  isViewerGeometryBackendError = exports.isViewerGeometryBackendError,
  isViewerDrawingToolsError = exports.isViewerDrawingToolsError,
  isViewerInteractionError = exports.isViewerInteractionError,
  isViewerValidationError = exports.isViewerValidationError,
  isARError = exports.isARError,
  isViewerCameraError = exports.isViewerCameraError,
  isViewerLightError = exports.isViewerLightError,
  isViewerViewportError = exports.isViewerViewportError,
  isViewerSessionError = exports.isViewerSessionError;